export type MathConditionUI = {
	math_script: any; //Transpiled math expression with parameters; iots-ready
	expression: string; //Math expression
	params: MathParameter[]; //A, B, C, etc. parameters
	_gui_type: 'math_based';
};

export type MathParameter = {
	name: string; //A, B, C, etc.
	value: string; //device iots parameter, e.g. dev:XXX:m1
};

export type MathDevicePropertyOption = {
	title: string; //Translated property name, e.g. 'Temperature'
	value: string; //Device parameter, e.g. temperature, meter, etc.
	disabled?: boolean; //If true, the option is not selectable
};

export function is_math_condition_ui(o: any): o is MathConditionUI {
	return (
		typeof o === 'object' &&
		o._gui_type === 'math_based' &&
		typeof o.math_script !== 'undefined' &&
		typeof o.expression === 'string' &&
		typeof o.params !== 'undefined'
	);
}
